import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Merged into /admin/players. This page redirects for backward compatibility.
const AdminPlayerAccounts = () => {
  const navigate = useNavigate();
  useEffect(() => { navigate('/admin/players', { replace: true }); }, [navigate]);
  return null;
};

export default AdminPlayerAccounts;
